__turbopack_context__.v({
  "accordionSlideOverwrite": "checkInQRCode-module-scss-module__9rZ3Tq__accordionSlideOverwrite",
  "container": "checkInQRCode-module-scss-module__9rZ3Tq__container",
  "description": "checkInQRCode-module-scss-module__9rZ3Tq__description",
  "fadeIn": "checkInQRCode-module-scss-module__9rZ3Tq__fadeIn",
  "fadeOut": "checkInQRCode-module-scss-module__9rZ3Tq__fadeOut",
  "qrWrapper": "checkInQRCode-module-scss-module__9rZ3Tq__qrWrapper",
  "scaleIn": "checkInQRCode-module-scss-module__9rZ3Tq__scaleIn",
  "scaleOut": "checkInQRCode-module-scss-module__9rZ3Tq__scaleOut",
  "title": "checkInQRCode-module-scss-module__9rZ3Tq__title",
  "zoomIn": "checkInQRCode-module-scss-module__9rZ3Tq__zoomIn",
  "zoomOut": "checkInQRCode-module-scss-module__9rZ3Tq__zoomOut",
});
